<template>
  <Form>
    <template v-if="readonly">
      <FormItem :label="$t('MATERIAL_TYPE')" class="twoColFlex">
        <span v-text="materialTypeCode"></span>
      </FormItem>
      <FormItem :label="$t('PROFIT_CENTER')" class="twoColFlex">
        <span v-text="quotation.profitCenter"></span>
      </FormItem>
      <FormItem :label="$t('FRA1')" class="twoColFlex">
        <span v-text="localFRA1"></span>
      </FormItem>
      <FormItem :label="$t('CUSTOM_DUTY_FOR_ZOA1')" class="twoColFlex">
        <span v-text="localZOA1"></span>
      </FormItem>
      <FormItem :label="$t('IMPORT_TAX_FOR_ZII1')" class="twoColFlex">
        <span v-text="localZII1"></span>
      </FormItem>
      <FormItem :label="$t('TRANSPORT_DAYS')" class="twoColFlex">
        <span v-text="quotation.transportDays"></span>
      </FormItem>
      <FormItem :label="$t('TAX_CODE')" class="twoColFlex">
        <span v-text="quotation.taxCode"></span>
      </FormItem>
      <FormItem :label="$t('PLAN_DELIVERY_TIME')" class="twoColFlex">
        <span v-text="quotation.planDelTime"></span>
      </FormItem>
      <FormItem :label="$t('MINIMUM_ORDER_QTY')" class="twoColFlex">
        <span v-text="quotation.minOrderQty"></span>
      </FormItem>
    </template>
    <template v-else>
      <FormItem :label="$t('MATERIAL_TYPE')" :required="true" class="twoColFlex">
        <Select v-model="materialTypeCode" :disabled="!quotation.materialTypeEditable">
          <Option v-for="material in materialTypeList" :value="material.code" :key="material.code">{{ material.description }}</Option>
        </Select>
      </FormItem>
      <FormItem :label="$t('PROFIT_CENTER')" class="twoColFlex">
        <span v-text="quotation.profitCenter"></span>
      </FormItem>
      <FormItem :label="$t('FRA1')" class="twoColFlex">
        <Input v-model="localFRA1" type="number" suffix="%" @on-keyup="handleInput($event, 'localFRA1')" />
      </FormItem>
      <FormItem :label="$t('CUSTOM_DUTY_FOR_ZOA1')" class="twoColFlex">
        <Input v-model="localZOA1" type="number" suffix="%" @on-keyup="handleInput($event, 'localZOA1')" />
      </FormItem>
      <FormItem :label="$t('IMPORT_TAX_FOR_ZII1')" class="twoColFlex">
        <Input v-model="localZII1" type="number" suffix="%" @on-keyup="handleInput($event, 'localZII1')" />
      </FormItem>
      <FormItem :label="$t('TRANSPORT_DAYS')" :required="true" class="twoColFlex">
        <Input v-model="quotation.transportDays" type="number" suffix="Days" />
      </FormItem>
      <FormItem :label="$t('TAX_CODE')" class="twoColFlex">
        <span v-text="quotation.taxCode"></span>
      </FormItem>
      <FormItem :label="$t('PLAN_DELIVERY_TIME')" :required="true" class="twoColFlex">
        <Input v-model="quotation.planDelTime" type="number" suffix="Days" />
      </FormItem>
      <FormItem :label="$t('MINIMUM_ORDER_QTY')" class="twoColFlex">
        <Input v-model="quotation.minOrderQty" type="number" />
      </FormItem>
    </template>
  </Form>
</template>

<script>
export default {
  name: "InfoRecordMaintain",
  props: {
    quotation: {
      type: Object,
      default: function() {
        return { materialType: {} };
      }
    },
    materialTypeList: {
      type: Array,
      default: function () {
        return [];
      }
    },
    readonly : {
      type: Boolean,
      default: function () {
        return false;
      }
    }
  },
  data() {
    return {
      localZOA1: (this.quotation.conditionMap && this.quotation.conditionMap.ZOA1 !== undefined) ? this.quotation.conditionMap.ZOA1 : "",
      localZII1: (this.quotation.conditionMap && this.quotation.conditionMap.ZII1 !== undefined) ? this.quotation.conditionMap.ZII1 : "",
      localFRA1: (this.quotation.conditionMap && this.quotation.conditionMap.FRA1 !== undefined) ? this.quotation.conditionMap.FRA1 : ""
    };
  },
  computed: {
    materialTypeCode: {
      get() {
        return this.quotation.materialType ? this.quotation.materialType.code : '';
      },
      set(value) {
        this.$set(this.quotation, 'materialType', { code: value });
      }
    }
  },
  methods: {
    handleInput(event, type) {
      const inputValue = event.target.value;
      this[type] = this.limitDecimal(inputValue);
      switch (type) {
        case "localZOA1":
          this.$set(this.quotation.conditionMap, "ZOA1", this[type]);
          break;
        case "localZII1":
          this.$set(this.quotation.conditionMap, "ZII1", this[type]);
          break;
        case "localFRA1":
          this.$set(this.quotation.conditionMap, "FRA1", this[type]);
          break;
      }
    },
    limitDecimal(value) {
      const [integerPart, decimalPart] = value.split('.');

      if (decimalPart && decimalPart.length > 3) {
        value = `${integerPart}.${decimalPart.slice(0, 3)}`;
      }
      return value;
    }
  }
}
</script>

<style>
.twoColFlex {
  display: flex;
  gap: 15px;
}
.twoColFlex label {
  flex-basis: 200px;
}
.twoColFlex .ivu-form-item-content {
  width: 250px;
}
</style>